import { render, staticRenderFns } from "./MyRequests.vue?vue&type=template&id=4f7c82ce&scoped=true&"
import script from "./MyRequests.vue?vue&type=script&lang=js&"
export * from "./MyRequests.vue?vue&type=script&lang=js&"
import style0 from "./MyRequests.vue?vue&type=style&index=0&id=4f7c82ce&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f7c82ce",
  null
  
)

export default component.exports